import client from '@libs/HttpClient';

class AllSprintService {
  /**
   * Get list of all sprints with optional search, page, status
   * @param {Object} request - react-query request object
   */
  static listAllSprint(request) {

    const page_no = request.page_no;
    const searchText = request.searchText || '';
    const projectIds = request.projectId?.join(',') || request.selectedProject?.join(',') || '';
    const managerIDs = request.managerID?.join(',') || '';
    const deliveryManagerIDs = request.deliveryManagerID?.join(',') || '';
    const paymentStatusTypesIDs = request.paymentStatusTypesID?.join(',') || '';
    const profitibilityStatusIDs = request.profitibilityStatusID?.join(',') || '';
    const selectedFilterDateBy = request.selectedFilterDateBy || '';
    const fromDate = request.fromDate || '';
    const toDate = request.toDate || '';

    return client.get(
      `/all-sprint?search=${searchText}&page=${page_no}&project_id=${projectIds}&manager_id=${managerIDs}&delivery_manager_id=${deliveryManagerIDs}&payment_status_id=${paymentStatusTypesIDs}&profitibility_id=${profitibilityStatusIDs}&filter_date_by=${selectedFilterDateBy}&from_date=${fromDate}&to_date=${toDate}`,
      request
    );
  }

  /**
   * Add a new sprint
   * @param {Object} request - sprint data
   */
  static addSprint(request) {
    return client.post(`/projects/sprint/add`, request);
  }

  /**
   * View sprint details
   * @param {number|string} id - sprint id
   */
  static viewSprint(id) {
    return client.get(`all-sprint/view/${id}`);
  }

  /**
   * Update sprint
   * @param {Object} request - sprint data including id
   */
  static updateSprint(request) {
    return client.put(`/projects/sprint/update/${request.id}`, request);
  }

  /**
   * Delete sprint
   * @param {Object} request - { id }
   */
  static deleteSprint(request) {
   return client.delete(`/all-sprint/${request.id}`);
  }

  /**
   * Change sprint status (if API supports)
   * @param {Object} request - { id, status }
   */
  static changeStatusSprint(request) {
    return client.patch(`/projects/sprint/status/${request.id}`, request);
  }
  static projectList(request) {
    return client.get(
      `/all-sprint/all-projects`,
      request
    );
  }

  /**
  * Sprint Project Count for next 7 days and today and overdue
  */
  static getSprintProjectCount(request) {
    return client.post(`/sprint-project-count`, request);
  }
}

export { AllSprintService };